module.exports = __webpack_public_path__ + "img/admin_icon_white.77564d71.svg";